import { ReactComponent as LostNetworkIllustration } from 'Assets/images/lost-network.svg';
import { VIDEO_HISTORY_NETWORK_ERROR_DESCRIPTION } from 'Modules/videoHistory/constants/networkError.constants';
import React from 'react';
import { EmptyState } from '~/lib/ui/emptyState';
import { NetworkEmptyStateProps } from './index.types';

export const NetworkEmptyState = ({
  testID,
}: NetworkEmptyStateProps) => (
  <EmptyState
    illustration={
      <LostNetworkIllustration
        aria-hidden
        className="block h-[79px] w-[118px] max-w-full object-contain"
      />
    }
    description={VIDEO_HISTORY_NETWORK_ERROR_DESCRIPTION}
    className="h-[65%] min-h-fit"
    descriptionClassName="whitespace-pre-line"
    testID={testID}
  />
);
